import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border/40">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="terms-back">
            <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center text-primary-foreground font-heading font-bold">T</div>
            <span className="font-heading font-bold text-xl">TUOTAX</span>
          </Link>
          <Link to="/"><Button variant="ghost" className="rounded-full"><ArrowLeft className="w-4 h-4 mr-2" /> Home</Button></Link>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-3">Termini di Servizio</div>
        <h1 className="font-heading font-bold text-4xl lg:text-5xl tracking-tighter mb-6">Le regole del gioco.</h1>
        <p className="text-muted-foreground mb-10">Ultimo aggiornamento: 16 febbraio 2026. Utilizzando TUOTAX accetti i seguenti termini.</p>

        <div className="space-y-6 text-sm leading-relaxed">
          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">1. Cos'è TUOTAX</h2>
            <p>TUOTAX ("il Servizio") è un'applicazione informativa che aiuta cittadini e piccole imprese italiane a monitorare e verificare la propria situazione fiscale e burocratica. Offre calcolatori, un assistente AI conversazionale, ricerca bandi pubblici, archivio documenti con OCR, import estratto conto e verifica fiscale.</p>
          </Card>

          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">2. Cosa NON è TUOTAX</h2>
            <p className="text-secondary font-semibold mb-2">TUOTAX NON è un servizio di consulenza fiscale.</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Non sostituisce un commercialista, un CAF, un revisore o qualsiasi professionista abilitato.</li>
              <li>Non ha accesso al tuo cassetto fiscale né trasmette dati all'Agenzia delle Entrate per tuo conto.</li>
              <li>Le simulazioni, i calcoli e le stime sono <strong>indicativi</strong>, basati sulla normativa vigente al momento della release. Non costituiscono consulenza personalizzata.</li>
            </ul>
          </Card>

          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">3. Registrazione e account</h2>
            <p>Per usare le funzionalità principali devi registrare un account fornendo email, password e alcune informazioni sul tuo profilo fiscale. Sei responsabile di mantenere sicura la password e di non condividere l'account con terzi.</p>
          </Card>

          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">4. I tuoi dati</h2>
            <p>Ti chiediamo di caricare volontariamente documenti, movimenti bancari, ricevute e dati personali per fornirti l'analisi. Tutti i dati restano nel tuo account e possono essere esportati o cancellati in qualsiasi momento dalle Impostazioni. Consulta la <Link to="/privacy" className="text-primary font-semibold underline">Privacy Policy</Link>.</p>
          </Card>

          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">5. Uso corretto</h2>
            <p>Ti impegni a usare TUOTAX in modo lecito. È vietato:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Caricare contenuti illegali, offensivi o non tuoi.</li>
              <li>Reverse engineering, scraping automatizzato o attacchi al Servizio.</li>
              <li>Utilizzare l'assistente AI per ottenere consulenze professionali che dovresti richiedere a un abilitato.</li>
              <li>Fornire dati falsi che possano alterare le simulazioni o i suggerimenti.</li>
            </ul>
          </Card>

          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">6. Limitazione di responsabilità</h2>
            <p>Il Servizio è fornito "così com'è". Non garantiamo la completa accuratezza dei calcoli né la disponibilità continua del servizio. Non siamo responsabili per decisioni fiscali, versamenti o omissioni prese sulla base delle sole informazioni di TUOTAX. <strong>Per pratiche ufficiali consulta sempre un professionista iscritto all'albo.</strong></p>
          </Card>

          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">7. Modifiche e cessazione</h2>
            <p>Ci riserviamo il diritto di modificare questi termini con preavviso via app o email. Puoi cancellare il tuo account in qualsiasi momento dalle Impostazioni. Possiamo sospendere account che violano queste condizioni.</p>
          </Card>

          <Card className="p-6 rounded-2xl border">
            <h2 className="font-heading font-semibold text-xl mb-3">8. Legge applicabile</h2>
            <p>I presenti termini sono regolati dalla legge italiana. Per ogni controversia il foro competente è quello del luogo di residenza del consumatore, salvo diverso accordo.</p>
          </Card>
        </div>

        <div className="mt-10 text-xs text-muted-foreground">
          Per domande scrivi a <a href="mailto:supporto@tuotax.it" className="text-primary underline">supporto@tuotax.it</a>.
        </div>
      </div>
    </div>
  );
}
